import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon } from "@material-ui/icons";
import { DatePicker as MuiDatePicker } from "@material-ui/pickers";
import moment from "moment";
import i18n from "../i18n";

// prop types
interface DatePickerProps {
    date: string,
    onSetDate: (date: string) => void,
}

// calendar top bar date picker
const DatePicker = ({ date, onSetDate }: DatePickerProps) => (
    <MuiDatePicker
        disableToolbar
        format="dd, Do MMM"
        InputProps={{
            endAdornment: (
                <Tooltip title={i18n.nextDay}>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            onSetDate(moment(date).add(1, "day").toISOString());
                        }}
                    >
                        <ChevronRightIcon />
                    </IconButton>
                </Tooltip>
            ),
            margin: "dense",
            startAdornment: (
                <Tooltip title={i18n.previousDay}>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            onSetDate(moment(date).subtract(1, "day").toISOString());
                        }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                </Tooltip>
            ),
            style: { padding: 0 },
        }}
        inputProps={{ // eslint-disable-line
            style: {
                maxWidth: "96px",
                textAlign: "center",
            },
        }}
        inputVariant="outlined"
        value={date}
        variant="inline"
        onChange={(m) => onSetDate(m!.toISOString())}
    />
);

export default DatePicker;
